import ssc from './ssc';
import xyrb from './xyrb';
import pk10 from './pk10';
import ks from './ks';
import hpten from './hpten'
export default (type, Vue) => {
  if (type == 'ssc') {
    return ssc();
  }
  if (type == 'xyrb') {
    return xyrb();
  }
  if (type == 'PK10' || type == 'nn') {
    return pk10();
  }
  if (type == 'ks') {
    return ks();
  }
  if (type == 'hpten') {
    return hpten()
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Zonghefenxi/columns/index.js